import gsap from 'gsap';

/**
 * Initializes GSAP-based scroll-triggered entrance animations.
 */
export function initScrollAnimations() {
  // Nav + hero entrance timeline
  const tl = gsap.timeline();
  tl.from('.glass-nav', { y: -100, opacity: 0, duration: 1, ease: 'power3.out' })
    .from('.hero-left', { y: 50, opacity: 0, duration: 1, ease: 'power3.out' }, '-=0.5')
    .from('.hero-right', { y: 30, opacity: 0, duration: 0.8, ease: 'power3.out' }, '-=0.6');

  // Intersection observer for section reveals
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          gsap.from(entry.target.children, {
            y: 50,
            opacity: 0,
            duration: 0.8,
            stagger: 0.2,
            ease: 'power2.out',
            clearProps: 'all',
          });
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 }
  );

  document
    .querySelectorAll('.work-section, .reels-section, .about-section, .contact-section')
    .forEach((s) => observer.observe(s));
}
